import {
    Typography,
    Box,
  } from '@material-ui/core';

const errorBlock = (props) => <Box my={2} ml={2}><Typography color="error" variant="body1" >{props.error}</Typography></Box>
export default errorBlock;